import React,{useState} from "react";
import {Spin} from "antd";
export const PageLoading = ()=>{
    let [loading,setLoading]= useState(true);
    window.addEventListener("load", function () {
        setLoading(false);
      },false)

    return <div id="pageLoading" className='page-loading' style={{display:loading?"grid":"none"}}><Spin size="large" />
    </div>
}